import React, { Component } from 'react';
import axios from 'axios';

export default axios;
